/**
 * 平台品牌文案（统一维护，避免前后端展示不一致）
 * 后端 init_db 演示数据中的公告/高校简介等请与此口径对齐。
 */
export const PLATFORM_NAME = "Python实训平台";

/** 门户/登录等品牌 Logo（public/portal-logo.png，已裁切留白，全站统一引用） */
export const PORTAL_LOGO_URL = "/portal-logo.png";

/** 后台侧栏收起时 Logo 缩写 */
export const PLATFORM_NAME_SHORT = "Py";

export const PLATFORM_TAGLINE = "构建你的 Python 编程能力";

export const PLATFORM_HERO_DESC =
  "从基础语法到项目实战，系统化课程与平台云端 IDE 助你掌握 Python 开发与数据分析。";

/** 对外展示统一品牌名（避免直接暴露第三方厂商名） */
export const PLATFORM_AI_BRAND = "平台AI";
export const PLATFORM_IDE_BRAND = "平台云端IDE";
export const PLATFORM_KB_BRAND = "平台知识库";

export const PLATFORM_LOGIN_SUB = "课程 · 在线 IDE · Python 实践";

export const PLATFORM_COPYRIGHT = "© 2026 " + PLATFORM_NAME;
